var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14118_55862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.78597H14.1667C14.3545 5.78597 14.5347 5.8606 14.6675 5.99344C14.8004 6.12627 14.875 6.30644 14.875 6.4943V14.9943C14.875 15.1822 14.8004 15.3623 14.6675 15.4952C14.5347 15.628 14.3545 15.7026 14.1667 15.7026H2.83333C2.64547 15.7026 2.4653 15.628 2.33247 15.4952C2.19963 15.3623 2.125 15.1822 2.125 14.9943V6.4943C2.125 6.30644 2.19963 6.12627 2.33247 5.99344C2.4653 5.8606 2.64547 5.78597 2.83333 5.78597H4.25V5.07764C4.25 3.95047 4.69777 2.86946 5.4948 2.07243C6.29183 1.2754 7.37283 0.827637 8.5 0.827637C9.62717 0.827637 10.7082 1.2754 11.5052 2.07243C12.3022 2.86946 12.75 3.95047 12.75 5.07764V5.78597ZM3.54167 7.20264V14.286H13.4583V7.20264H3.54167ZM7.79167 10.036H9.20833V11.4526H7.79167V10.036ZM4.95833 10.036H6.375V11.4526H4.95833V10.036ZM10.625 10.036H12.0417V11.4526H10.625V10.036ZM11.3333 5.78597V5.07764C11.3333 4.32619 11.0348 3.60552 10.5035 3.07417C9.97212 2.54281 9.25145 2.2443 8.5 2.2443C7.74855 2.2443 7.02788 2.54281 6.49653 3.07417C5.96518 3.60552 5.66667 4.32619 5.66667 5.07764V5.78597H11.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14118_55862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.119141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.399c1326af7fe3237b3324ddb92d714c.svg";
export { ForwardRef as ReactComponent };